<div class="pme-container" style="margin-top:0">
    <pme-window-shop-manager-header *ngIf="this.headerContent" [headerContent]="this.headerContent">
    </pme-window-shop-manager-header>
    <!--PRODUCT LISTING-->
    <!--Desktop view -->
    <div class="display-utils-row display-utils-lt-md-col display-utils-center-center display-utils-gap-160">

        <div class="pme-carousel-swiper-container" style="width:98%;">
            <ng-container *ngIf="plans ">
                <pme-carousel-swiper [identifier]="'sdsn-products'" [items]="plans">
                    <ng-template let-product let-i="index">
                        <pme-product-sdsn [shopWindowItem]="product" (clickOnProduct)="navigate(i)" [elementIndex]="i">
                        </pme-product-sdsn>
                    </ng-template>
                </pme-carousel-swiper>
            </ng-container>
        </div>
    </div>
    <!-- end Desktop view -->

    <!--Mobile view -->

    <!-- end Mobile view -->
    <!-- end Product Listing -->
    <pme-comparative-sdsn [shopWindowItems]="plans"></pme-comparative-sdsn>
    <mat-divider class="divider"></mat-divider>
    <div *ngIf="legalNotes?.length">
        <ul>
            <li *ngFor="let note of legalNotes" style="font-size: 14px; font-family: Roboto;">
                {{ note }}
            </li>
        </ul>
    </div>
    <mat-divider class="divider"></mat-divider>
    <pme-payment-methods></pme-payment-methods>
    <mat-divider class="divider"></mat-divider>
</div>